module.exports = __webpack_public_path__ + "img/Mapa-B.2833c845.svg";